import React, { useState, useEffect } from 'react'

function RecipeDetailCommon(props) {

    return (
        <div>
            <input type="hidden" id="tooltitle" value={props.fields.title.value} />         
            <input type="hidden" id="keywordlink" value={props.fields.SearchByKeywordUrl.value.href} />
            <input type="hidden" id="brandlogo" value={props.fields.brandLogo.value.src} />
            <input type="hidden" id="toollogo" value={props.fields.topLogo.value.src} />
            <input type="hidden" id="recaptchaseckey" value={props.fields.recaptchaData.fields.recaptchaSecretKey.value} />
            <input type="hidden" id="recaptchasitekey" value={props.fields.recaptchaData.fields.recaptchaSiteKey.value} />
            <input type="hidden" id="emailsubject" value={props.fields.shareTemplate.fields.subject.value} />
        </div>        
    );
}

export default RecipeDetailCommon;